/* eslint-disable react/prefer-stateless-function,no-unused-vars,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import {
  changeFieldTimeTargetDeleteWeekdays,
  changeFieldTimeTargetChangeWeekdays,
  changeFieldTimeTargetAddTimeRange
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { t } from 'utils/translates';
import { selectFieldTimeTarget } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import TimeTargetWeekDaysTimeRanges from './TimeTargetWeekDaysTimeRangeItem';

class TimeTargetWeekDaysItem extends Component {
  weekDaysAssortedArrayMap = () => {
    // Делаем мап по объекту с днями недели и кидаем вс(0) в конец списка
    const weekDaysAsArray = Object.keys(this.props.weekdays).map(v =>
      parseInt(v, 10)
    );
    weekDaysAsArray.push(weekDaysAsArray.shift());
    return weekDaysAsArray;
  };

  render() {
    return (
      <React.Fragment>
        <div
          className="panel panel-heading_padding-large panel-default m-b-20"
          id="periodTime0"
        >
          <div className="panel-heading panel-inner-border-bottom">
            <div className="media full-width">
              <div className="media-body media-middle full-width">
                <div className="form-group m-b-0 m-t-5">
                  <label className="control-label sr-only" htmlFor={'0'}>
                    {t('Дни выполнения')}
                  </label>
                  <div className="control-group">
                    {this.weekDaysAssortedArrayMap().map(dayInt => {
                      const keyElement = `weekDays-${this.props.weekDaysIndex}-${dayInt}`;
                      return (
                        <div
                          key={keyElement}
                          className="checkbox abc-checkbox checkbox-inline"
                        >
                          <input
                            className="styled"
                            type="checkbox"
                            checked={
                              this.props.weekDayTimeTargetItem.value.weekdays.value.indexOf(
                                dayInt
                              ) !== -1
                                ? 'checked'
                                : ''
                            }
                            id={keyElement}
                            onChange={() =>
                              this.props.changeFieldTimeTargetChangeWeekdays({
                                blockIdx: this.props.weekDaysIndex,
                                weekday: dayInt
                              })
                            }
                          />
                          <label htmlFor={keyElement}>
                            {' '}
                            {this.props.weekdays[dayInt]}{' '}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div
                className="media-right media-middle text-overflow"
                data-placement="top"
                data-toggle="tooltip"
                data-original-title={t('Удалить')}
              >
                <button
                  className="btn btn-default"
                  type="button"
                  onClick={() =>
                    this.props.changeFieldTimeTargetDeleteWeekdays(
                      this.props.weekDaysIndex
                    )
                  }
                >
                  <i className="fa fa-trash" />
                </button>
              </div>
            </div>
          </div>
          <div className="panel-body">
            <label className="control-label" htmlFor={'0'}>
              {t('Время выполнения')}:
            </label>
            {this.props.weekDayTimeTargetItem.value.times.value.map(
              (item, index) => (
                <TimeTargetWeekDaysTimeRanges
                  key={`timeTargetWeekDaysTimeRanges-${
                    this.props.weekDaysIndex
                  }-${index + 1}`}
                  reducerName={this.props.reducerName}
                  weekDaysIndex={this.props.weekDaysIndex}
                  timeRangeIndex={index}
                  timeRangeItem={item}
                />
              )
            )}
            <div className="form-inline text-nowrap form-inline_no-breakpoint m-b-15">
              <div className="form-group m-b-0">
                <p className="form-control-static">&nbsp;&nbsp;&nbsp;</p>
              </div>
              <div className="form-group m-b-0">
                <button
                  className="btn btn-default"
                  type="button"
                  id="addPeriod1"
                  onClick={() =>
                    this.props.changeFieldTimeTargetAddTimeRange({
                      weekDaysIndex: this.props.weekDaysIndex
                    })
                  }
                >
                  <i className="fa fa-plus" /> {t('Добавить время выполнения')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TimeTargetWeekDaysItem.propTypes = {
  reducerName: PropTypes.string.isRequired,
  weekDaysIndex: PropTypes.number.isRequired,
  weekDayTimeTargetItem: PropTypes.shape({
    value: PropTypes.shape({
      weekdays: PropTypes.shape({
        value: PropTypes.any.isRequired,
        errors: PropTypes.array.isRequired
      }).isRequired,
      times: PropTypes.shape({
        value: PropTypes.any.isRequired,
        errors: PropTypes.array.isRequired
      }).isRequired
    })
  }).isRequired,

  // STATE
  weekdays: PropTypes.shape({}).isRequired,
  fieldTimeTarget: PropTypes.shape({
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldTimeTargetDeleteWeekdays: PropTypes.func.isRequired,
  changeFieldTimeTargetChangeWeekdays: PropTypes.func.isRequired,
  changeFieldTimeTargetAddTimeRange: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  weekdays: getItemFromRefList(state, 'weekdays'),
  fieldTimeTarget: selectFieldTimeTarget(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldTimeTargetDeleteWeekdays: weekDayKey =>
    dispatch(
      changeFieldTimeTargetDeleteWeekdays(props.reducerName, weekDayKey)
    ),
  changeFieldTimeTargetChangeWeekdays: payload =>
    dispatch(changeFieldTimeTargetChangeWeekdays(props.reducerName, payload)),
  changeFieldTimeTargetAddTimeRange: payload =>
    dispatch(changeFieldTimeTargetAddTimeRange(props.reducerName, payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeTargetWeekDaysItem);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/TimeTargetTaskInputs/TimeTargetWeekDaysItem/TimeTargetWeekDaysItem.js